import axios from 'axios';
import React, { useEffect, useState } from 'react';
import { HiOutlinePhone, HiOutlineEnvelope } from 'react-icons/hi2';
import { FaFacebookF } from 'react-icons/fa'
import { BiLogoInstagram, BiLogoTwitter } from 'react-icons/bi';
import { IoClose, IoMenu } from 'react-icons/io5';
import { Link } from 'react-router-dom';
import pharmtrixLogo from '../../assets/Pharmtrix Logo bl.svg'

const ADMIN_URL = process.env.REACT_APP_ADMIN_URL.replace(/\/?$/, '/signup');

const HomeNav = ({ contactRef, servicesRef, homeRef }) => {
    const [data, setData] = useState([])
    const [menu, setMenu] = useState(false)

    const toggleMenu = () => {
        setMenu(!menu)
    }

    const scrollToSection = (ref) => {
        if (ref?.current) {
            ref.current.scrollIntoView({ behavior: 'smooth' });
            setMenu(false);
        }
    };

    const scrollToTop = () => {

        window.scrollTo({ top: 0, behavior: 'smooth' })

    }

    const handleCreateAccountClick = () => {
        window.open(ADMIN_URL, '_blank');
    };

    const handleLoginClick = () => {
        window.open('/login', '_blank');
    };

    useEffect(() => {
        const fetchData = async () => {
            try {
                const locationResponse = await axios.get('https://ipapi.co/json');
                if (locationResponse.data.city) {
                    const url = `https://restcountries.com/v3.1/capital/${locationResponse.data.city}`;
                    const dataResponse = await axios.get(url);
                    setData(dataResponse.data);
                    console.log(dataResponse.data);
                }
            } catch (error) {
                console.error('Error fetching data:', error);
            }
        };

        fetchData();
    }, []);

    return (
        <div className='sticky top-0 z-50 w-full mb-5 bg-white shadow-md'>
            <div
                className='w-full lg:max-w-[85%] mx-auto px-4'
            >
                <div className=''>
                    {/* Desktop Navigation */}
                    <div className='items-center justify-between hidden py-4 md:flex lg:py-6'> {/* Smaller base padding */}
                        <div className='flex flex-row items-center mt-3'>
                            <Link to='/' className=''>
                                <img
                                    src={pharmtrixLogo}
                                    className='w-auto h-8 mr-2 lg:h-10 object-fit md:mr-3 lg:mr-4' // Responsive size/margin
                                    alt='company logo'
                                />
                            </Link>

                            <ul className='flex flex-row items-center self-center'>
                                <Link to='/' onClick={() => scrollToTop()}>
                                    <li
                                        className='mx-3 lg:mx-5 text-sm lg:text-base text-black hover:text-[#00A9FF] cursor-pointer font-semibold transition-colors duration-200'
                                    >HOME</li>
                                </Link>
                                <button
                                    onClick={() => scrollToSection(contactRef)}
                                    className='mx-3 lg:mx-5 text-sm lg:text-base text-black hover:text-[#00A9FF] cursor-pointer font-semibold transition-colors duration-200'
                                >CONTACT US</button>
                            </ul>
                        </div>
                        <div
                            className='flex flex-row items-center'
                        >
                            <button
                                onClick={handleCreateAccountClick}
                                className='text-sm lg:text-base text-black cursor-pointer font-medium border-2 border-blue-500 rounded-full px-3 py-1.5 lg:px-5 lg:py-2 mr-2 lg:mr-3 transition-colors hover:bg-blue-50' // Added standard hover 
                            >
                                Setup Account
                            </button>
                            <button
                                onClick={handleLoginClick}
                                className='text-sm lg:text-base text-white bg-gradient-to-r from-[#18487F] to-[#27C4F4] cursor-pointer font-medium  border-blue-500 px-4 py-1.5 lg:px-8 lg:py-2.5 rounded-full mr-2 lg:mr-4 transition-transform hover:scale-105' // Added standard hover 
                            >
                                Log in
                            </button>

                            <div className='flex items-center gap-1'> {/* Reduced gap */}
                                <img src={data[0]?.flags.png} alt='/' className='w-6 h-6 rounded-full lg:h-8 lg:w-8' /> {/* Responsive size */}
                            </div>
                        </div>
                    </div>

                    {/* Mobile Navigation Trigger */}
                    <div className='md:hidden'>
                        <div
                            className='relative flex items-center justify-between py-3' // Adjusted padding
                        >
                            <img src={pharmtrixLogo} alt="Pharmtrix Logo" className="w-auto h-7" /> {/* Added Logo */}
                            <div className='flex items-center gap-2'>
                                <button
                                    className='text-xs sm:text-sm text-white bg-gradient-to-r from-[#18487F] to-[#27C4F4] cursor-pointer font-medium border-blue-500 px-3 py-1 sm:px-4 sm:py-1.5 rounded-full transition-transform active:scale-95' // Added standard active state
                                    onClick={handleLoginClick}
                                >
                                    Log in
                                </button>
                                <div className='cursor-pointer'> {/* Kept onClick here */}
                                    <IoMenu size={30} onClick={toggleMenu} />
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                {/* Overlay for Mobile Menu - Using Tailwind transitions */}
                {menu && (
                    <div
                        className="fixed inset-0 z-40 transition-opacity duration-300 ease-in-out bg-black/50 md:hidden" // Added transition
                        onClick={toggleMenu}
                    />
                )}

                {/* Mobile Menu Drawer - Using Tailwind transitions */}
                <div
                    className={`md:hidden fixed top-0 left-0 h-full w-4/5 max-w-xs bg-[#e1f5ff] shadow-lg p-4 z-50 transition-transform duration-300 ease-in-out ${menu ? 'translate-x-0' : '-translate-x-full'}`} // Added transform classes for slide
                >
                    <div className='flex items-center justify-between mb-6'> {/* Container for Logo and Close */}
                        <img src={pharmtrixLogo} alt="Pharmtrix Logo" className="w-auto h-8" />
                        <div className='cursor-pointer'>
                            <IoClose size={24} onClick={toggleMenu} />
                        </div>
                    </div>
                    <div className='flex flex-col items-center flex-1'>
                        {/* Mobile Menu Links */}
                        <ul className='flex flex-col items-center flex-1 w-full gap-4 mb-8'> {/* Adjusted gap/margin */}
                            <Link to='/' className='w-full'>
                                <li
                                    className='py-1.5 text-center text-base font-semibold w-full hover:bg-blue-100 rounded transition-colors' // Added standard hover/transition
                                >HOME</li>
                            </Link>
                            <button
                                onClick={handleCreateAccountClick}
                                className='py-1.5 text-center text-base font-semibold w-full hover:bg-blue-100 rounded transition-colors' // Added standard hover/transition
                            >
                                SETUP ACCOUNT
                            </button>
                            <button
                                onClick={() => { scrollToSection(servicesRef); toggleMenu(); }}
                                className='py-1.5 text-center text-base font-semibold w-full hover:bg-blue-100 rounded cursor-pointer transition-colors'
                            >SERVICES</button>
                            <button
                                onClick={() => { scrollToSection(contactRef); toggleMenu(); }}
                                className='py-1.5 text-center text-base font-semibold w-full hover:bg-blue-100 rounded cursor-pointer transition-colors'
                            >CONTACT US</button>
                        </ul>
                        {/* Mobile Menu Contact Info */}
                        <ul className='flex flex-col items-center justify-center w-full gap-3 pt-4 border-t border-gray-300'> {/* Adjusted gap/padding */}
                            <li className='w-full'>
                                <p className='text-center text-xs text-black font-lufga flex items-center justify-center gap-1.5'> {/* Adjusted size/gap */}
                                    <HiOutlinePhone size={20} className='text-[#00A9FF]' />
                                    +233 (0)30 396 4289
                                </p>
                            </li>
                            <li className='w-full'>
                                <p className='text-center text-xs text-black font-lufga flex items-center justify-center gap-1.5'> {/* Adjusted size/gap */}
                                    <HiOutlineEnvelope size={20} className='text-[#00A9FF]' />
                                    info@ntubedglobal.com
                                </p>
                            </li>
                            <li className='flex items-center justify-center gap-3 mt-3'> {/* Adjusted gap/margin */}
                                <a href="/#" target="_blank" className='transition-transform hover:scale-110'><BiLogoInstagram size={24} className='cursor-pointer' /></a>
                                <a href="/#" target="_blank" className='transition-transform hover:scale-110'><FaFacebookF size={22} className='cursor-pointer' /></a>
                                <a href="/#" target="_blank" className='transition-transform hover:scale-110'><BiLogoTwitter size={24} className='cursor-pointer' /></a>
                            </li>
                            <li className='flex items-center gap-1 mt-3'> {/* Adjusted gap/margin */}
                                <img src={data[0]?.flags.png} alt='/' className='w-5 h-5 rounded-full' /> {/* Adjusted size */}
                            </li>
                        </ul>
                    </div>
                </div>
            </div>
        </div>
    );
}

export default HomeNav;